import { useState, useEffect } from "react";

import { useGetUserRoles } from "../user-roles/hooks/useGetRolesPageApi";
import api from "../../../api/api";

const DropdownComponent = ({ getFirmUserType, getUserRoles }) => {
  const [selectedRole, setSelectedRole] = useState({});
  const { refetch } = useGetUserRoles();

  useEffect(() => {
    if (getUserRoles?.for_firmusertype) {
      setSelectedRole(getUserRoles.for_firmusertype);
    } else {
      setSelectedRole(getFirmUserType[0]);
    }
  }, [getFirmUserType, getUserRoles]);

  const handleChange = async (e) => {
    const selectedId = parseInt(e.target.value);
    const selected = getFirmUserType.find((role) => role.id === selectedId);
    setSelectedRole(selected);
    try {
      const _response = await api.post("/api/firmsetting-page/update-user-type/", {
        user_id: getUserRoles?.id,
        user_type_id: selected?.id,
      });

      refetch();
    } catch (error) {
      console.error("Error uploading avatar:", error);
    }
  };

  return (
    <div>
      <select
        value={selectedRole?.id || getFirmUserType[0]?.id}
        onChange={handleChange}
        className="form-select line-height-in py-0 p-l-5 p-r-15"
        style={{ height: "25px" }}
      >
        {getFirmUserType?.map((role) => (
          <option key={role.id} value={role.id}>
            {role.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DropdownComponent;
